// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import { useState, useEffect } from 'react';
import '../styles/InterpretingSignals.animations.css';
import * as styles from '../styles/InterpretingSignals.styles';
import signalsinthesisSvg from '../assets/images/signalsinthesis.svg';

const STEPS = [
  'ISOLATING OBSERVED SKILL SIGNALS',
  'BENCHMARKING AGAINST LEAD EXPECTATIONS',
  'GENERATING DEVELOPMENTAL GROWTH PATHS'
];

const LOADER_REVEAL_DELAY_MS = 700;

const SparkleIcon = (): JSX.Element => <img src={signalsinthesisSvg} width={160} alt="" />;

export const InterpretingSignalsView = (): JSX.Element => {
  const [contentRevealed, setContentRevealed] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setContentRevealed(true), LOADER_REVEAL_DELAY_MS);
    return () => clearTimeout(t);
  }, []);

  return (
    <div style={styles.root} className="interpreting-signals-fade-in">
      <div style={styles.iconWrapper}>
        <div style={styles.loaderWrapper}>
          <div style={styles.loaderRing} className="interpreting-signals-spinner" aria-hidden="true" />
        </div>
      </div>
      <div
        className={`interpreting-signals-content${contentRevealed ? ' interpreting-signals-content-revealed' : ''}`}
        style={styles.contentStaggerWrap}
      >
        <div style={styles.sectionLabel}>
          <span style={styles.sectionLabelLine} />
          <span style={styles.sectionLabelText}>Signal Synthesis</span>
          <span style={styles.sectionLabelLine} />
        </div>
        <h2 style={styles.title}>Interpreting Signals</h2>
        <p style={styles.description}>Aggregating conversational data for AI literacy skill assessment framework</p>
        <div style={styles.stepList}>
          {STEPS.map((label) => (
            <div key={label} style={styles.stepItem}>
              <span style={styles.stepDot} />
              <span style={styles.stepLabel}>{label}</span>
              <span style={styles.stepDots}>⋯</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
